import { j as c } from "./jsx-runtime-944c88e2.js";
import o, { forwardRef as h, useState as s, useMemo as j } from "react";
function R(i) {
  return h(function(t, l) {
    const [a, d] = s(""), g = (e) => {
      var u;
      (u = t.onFilterChange) == null || u.call(t, e);
      const n = e.filter.value;
      d(n);
    }, x = (e, n) => {
      var f;
      const u = t != null && t.textField ? (f = n.dataItem) == null ? void 0 : f[t.textField] : n.dataItem, F = /* @__PURE__ */ c.jsx(w, { text: u, filter: a });
      return o.cloneElement(e, e.props, F);
    };
    return /* @__PURE__ */ c.jsx(i, { ...t, onFilterChange: g, itemRender: x, ref: l, suggest: !0 });
  });
}
function w({ text: i, filter: r }) {
  if (!i)
    return null;
  if (!r)
    return /* @__PURE__ */ c.jsx("span", { children: i });
  const t = i.split(new RegExp(`(${r})`, "gi"));
  return /* @__PURE__ */ c.jsx("span", { children: t.map((l, a) => l.toLowerCase() === r.toLowerCase() ? /* @__PURE__ */ c.jsx("b", { children: l }, a) : l) });
}
function v(i) {
  return h(function(t, l) {
    const [a, d] = s(t.value), g = j(
      () => {
        var e;
        return ((e = t.data) == null ? void 0 : e.filter(
          (n) => new RegExp(`(${a == null ? void 0 : a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi").test(
            t.textField ? n == null ? void 0 : n[t.textField] : n
          )
        )) || [];
      },
      [t.data, t.textField, a]
    ), x = (e) => {
      var u;
      (u = t.onFilterChange) == null || u.call(t, e);
      const n = e.filter.value;
      d(n);
    };
    return /* @__PURE__ */ c.jsx(i, { ...t, data: g, filterable: !0, onFilterChange: x, ref: l });
  });
}
export {
  v as a,
  R as w
};
